'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContrastText = exports.isDark = exports.shades = exports.dark = exports.light = undefined;
exports['default'] = createPalette;

var _colors = require('./colors');

var _colorManipulator = require('./colorManipulator');

var light = exports.light = {
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.26)'
  },
  background: {
    appBar: _colors.grey[100],
    contentFrame: _colors.grey[200],
    'default': _colors.navy[50],
    detailPane: _colors.grey[25],
    forms: 'rgba(200, 200, 200, 0.1)',
    highlight: _colors.marine[50],
    paper: _colors.white,
    searchInput: _colors.grey[25],
    status: _colors.grey[300]
  },
  drawer: {
    background: {
      primary: _colors.grey[25],
      active: _colors.grey[100]
    },
    icon: {
      primary: _colors.marine[500],
      active: _colors.marine[500]
    },
    text: {
      primary: _colors.navy[500],
      active: _colors.navy[500]
    }
  },
  forms: {
    primary: _colors.lightGrey,
    active: _colors.lighterGrey
  },
  text: {
    disabled: _colors.navy[100],
    divider: _colors.grey[200],
    error: _colors.red[500],
    highlight: _colors.marine[500],
    lighterDivider: _colors.grey[50],
    lightDivider: _colors.grey[100],
    primary: _colors.navy[500],
    secondary: _colors.navy[300],
    success: _colors.green[500]
  }
};

var dark = exports.dark = {
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.26)'
  },
  background: {
    appBar: _colors.grey[100],
    contentFrame: _colors.grey[200],
    detailPane: _colors.grey[25],
    forms: 'rgba(200, 200, 200, 0.1)',
    'default': _colors.navy[50],
    highlight: _colors.marine[50],
    paper: _colors.white,
    searchInput: _colors.grey[25],
    status: _colors.grey[300]
  },
  drawer: {
    background: {
      primary: _colors.navy[500],
      active: _colors.marine[500]
    },
    icon: {
      primary: _colors.grey[200],
      active: _colors.white
    },
    text: {
      primary: _colors.grey[200],
      active: _colors.white
    }
  },
  forms: {
    primary: _colors.lightGrey,
    active: _colors.lighterGrey
  },
  text: {
    disabled: _colors.navy[100],
    divider: _colors.grey[200],
    error: _colors.red[500],
    highlight: _colors.marine[500],
    lighterDivider: _colors.grey[50],
    lightDivider: _colors.grey[100],
    primary: _colors.navy[500],
    secondary: _colors.navy[300],
    success: _colors.green[500]
  }
};

var shades = exports.shades = { light: light, dark: dark };

var isDark = exports.isDark = function isDark(color) {
  return (0, _colorManipulator.getContrastRatio)(color, _colors.black) < 7;
};

var getContrastText = exports.getContrastText = function getContrastText(color) {
  return isDark(color) ? _colors.navy[50] : _colors.navy[500];
};

function createPalette() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$accent = _ref.accent,
      accent = _ref$accent === undefined ? _colors.marine : _ref$accent,
      _ref$error = _ref.error,
      error = _ref$error === undefined ? _colors.red : _ref$error,
      _ref$primary = _ref.primary,
      primary = _ref$primary === undefined ? _colors.navy : _ref$primary,
      _ref$success = _ref.success,
      success = _ref$success === undefined ? _colors.green : _ref$success,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'dark' : _ref$type;

  return {
    accent: accent,
    action: shades[type].action,
    background: shades[type].background,
    drawer: shades[type].drawer,
    error: error,
    forms: shades[type].forms,
    getContrastText: getContrastText,
    grey: _colors.grey,
    isDark: isDark,
    primary: primary,
    shades: shades,
    success: success,
    text: shades[type].text,
    type: type
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/styles/palette.js
// module id = 563
// module chunks = 32